export const activeMapStyle = [
    {
        elementType: 'geometry',
        stylers: [{ color: '#ecf1f6' }],
    },
    {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#ecf1f6' }],
    },
    {
        featureType: 'administrative',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#8b929c' }],
    },
    {
        featureType: 'administrative',
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#f5f5f5' }, { weight: '2' }],
    },
    {
        featureType: 'administrative.neighborhood',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#d6d6d6' }, { weight: '1' }],
    },
    {
        featureType: 'administrative.land_parcel',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#ffffff' }, { weight: '2' }],
    },
    {
        featureType: 'landscape.man_made',
        elementType: 'geometry.fill',
        stylers: [{ color: '#ecf1f6' }],
    },
    {
        featureType: 'landscape.man_made',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#BABFC8' }, { weight: '2' }],
    },
    {
        featureType: 'landscape.natural',
        elementType: 'geometry',
        stylers: [{ color: '#bcdad1' }],
    },
    {
        featureType: 'landscape.natural.landcover',
        elementType: 'geometry',
        stylers: [{ color: '#ccebd7' }],
    },
    {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{ color: '#d7f0e0' }],
    },
    {
        featureType: 'poi.business',
        elementType: 'all',
        stylers: [{ visibility: 'off' }],
    },
    {
        featureType: 'poi.government',
        elementType: 'all',
        stylers: [{ visibility: 'off' }],
    },
    {
        featureType: 'poi.medical',
        elementType: 'geometry',
        stylers: [{ color: '#f4e1e1' }],
    },
    {
        featureType: 'poi.medical',
        elementType: 'labels.icon',
        stylers: [{ color: '#f9b9b9' }],
    },
    {
        featureType: 'poi.medical',
        elementType: 'labels.text',
        stylers: [{ visibility: 'off' }],
    },
    {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ color: '#d7f0e0' }],
    },
    {
        featureType: 'poi.park',
        elementType: 'labels.text',
        stylers: [{ visibility: 'off' }],
    },
    {
        featureType: 'poi.attraction',
        elementType: 'labels.icon',
        stylers: [{ color: '#a4abbe' }],
    },
    {
        featureType: 'poi.attraction',
        elementType: 'labels.text',
        stylers: [{ visibility: 'off' }],
    },
    {
        featureType: 'poi.place_of_worship',
        elementType: 'all',
        stylers: [{ visibility: 'off' }],
    },
    {
        featureType: 'poi.school',
        elementType: 'geometry',
        stylers: [{ color: '#dae1ec' }],
    },
    {
        featureType: 'poi.school',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
    },
    {
        featureType: 'poi.sports_complex',
        elementType: 'all',
        stylers: [{ visibility: 'off' }],
    },
    {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#fafafa' }],
    },
    {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#8b929c' }],
    },
    {
        featureType: 'road',
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#f5f5f5' }],
    },
    {
        featureType: 'road.highway',
        elementType: 'geometry.fill',
        stylers: [{ color: '#fff7e4' }],
    },
    {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#f9da8d' }],
    },
    {
        featureType: 'road.highway',
        elementType: 'labels.text',
        stylers: [{ visibility: 'off' }],
    },
    {
        featureType: 'transit',
        elementType: 'labels.icon',
        stylers: [{ color: '#a4abbe' }],
    },
    {
        featureType: 'transit',
        elementType: 'labels.text',
        stylers: [{ visibility: 'off' }],
    },
    {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#c3dff9' }],
    },
    {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#8b929c' }],
    },
];

export const inactiveMapStyle = [
    {
        elementType: 'geometry.fill',
        stylers: [
            {
                saturation: -100,
            },
            {
                lightness: 50,
            },
        ],
    },
    {
        elementType: 'geometry.stroke',
        stylers: [
            {
                saturation: -100,
            },
            {
                lightness: 50,
            },
        ],
    },
    {
        elementType: 'labels',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'poi',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'road',
        stylers: [
            {
                lightness: 100,
            },
        ],
    },
    {
        featureType: 'transit',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
];
